export default __webpack_public_path__ + "static/media/elle6.c6775090.webp";